import {
  getReviewStatus,
  getReviewFirstWord,
  submitReviewAnswer,
  getReviewNextWord,
} from "@/api/common";

export default {
  data() {
    return {
      
      needForcedReview: false,
      
      checkingReviewStatus: false,
      
      reviewType: "1",
      
      reviewGroupid: null,
      
      dictationDialogVisible: false,
      
      write: "",
    };
  },
  methods: {
    initgetReviewStatus() {
      getReviewStatus().then((res) => {
        if (res.data) return (this.dialogVisible = true);
      });
    },
    handleStartTest() {
      this.showLearningCompletedDialog = false;
      this.dialogVisible = false;

      
      getReviewFirstWord().then((res) => {
        const data = res?.data || {};
        const vocabularyInfo = data?.vocabulary_info || {};
        const currentIndex = data?.current_index || 0;
        const total = data?.total || 0;

        
        this.reviewType = data?.type || "1";
        
        this.reviewGroupid = data?.groupid || null;

        
        this.wordBookData = {
          ...data,
          vocabulary_info: vocabularyInfo,
          info: data?.info || {},
        };

        
        this.wordBookProgress = `${currentIndex}/${total}`;

        
        this.wordBookTitle = "强制复习";

        
        if (data?.info?.type === "write") {
          this.write = ""; 
          this.dictationDialogVisible = true;
          this.showWordBookDialog = false;
           this.pay(data);
        } else {
          this.showWordBookDialog = true;
          this.dictationDialogVisible = false;
          
          
          
          
          
        }
      });
    },
    pay(data) {
      let attachfile = data?.vocabulary_info?.attachfile;
      if (!attachfile) {
        this.$message.warning("音频文件不存在");
        return;
      }
      
      const audio = new Audio(attachfile);
      audio.play().catch((error) => {
        this.$message.error("播放音频失败，请稍后重试");
      });
    },
    
    smilingFace() {
      if (!this.showWordBookDialog) {
        return;
      }

      
      const wordBookDialog = this.$refs.wordBookDialog;
      if (wordBookDialog && wordBookDialog.isFlipped === true) {
        
        
        if (wordBookDialog.resetFlip) {
          wordBookDialog.resetFlip();
        }

        
        this.waitForCardFlip().then(() => {
          this.handleSmilingFaceSubmit();
        });
        return;
      }

      
      this.handleSmilingFaceSubmit();
    },

    
    waitForCardFlip() {
      return new Promise((resolve) => {
        let checkCount = 0;
        const maxChecks = 30; 

        const checkFlip = () => {
          checkCount++;
          const wordBookDialog = this.$refs.wordBookDialog;

          
          if (!wordBookDialog || wordBookDialog.isFlipped === false) {
            
            setTimeout(() => {
              resolve();
            }, 100);
            return;
          }

          
          if (checkCount >= maxChecks) {
            console.warn("等待卡片翻转超时，强制继续");
            resolve();
            return;
          }

          
          setTimeout(checkFlip, 50);
        };
        checkFlip();
      });
    },

    
    handleSmilingFaceSubmit() {
      const difficultStudyId = this.wordBookData?.info?.id;
      const currentIndex = parseInt(this.wordBookData?.current_index || "0");
      const total = parseInt(this.wordBookData?.total || "0");
      if (!difficultStudyId) {
        this.$message?.error("数据不完整，无法提交答案");
        return;
      }

      
      submitReviewAnswer({
        type: this.reviewType,
        difficultStudyId: difficultStudyId.toString(),
        currentIndex: currentIndex.toString(),
        action: "1", 
        answer: "", 
      }).then((res) => {
        
        if (currentIndex === total && total > 0) {
          this.$message?.success("复习完成！");
          localStorage.setItem("need-review", "false");
          this.showWordBookDialog = false;
          this.dictationDialogVisible = false;
          this.reviewGroupid = null;
          return;
        }
        
        this.loadReviewNextWord();
      });
    },
    
    loadReviewNextWord() {
      if (!this.reviewGroupid) {
        this.$message?.error("无法获取下一个单词，请重新开始学习");
        return;
      }

      
      const currentIndex = parseInt(this.wordBookData?.current_index || "1");
      const total = parseInt(this.wordBookData?.total || "0");

      
      if (currentIndex === total && total > 0) {
        this.$message?.success("复习完成！");
        localStorage.setItem("need-review", "false");
        this.showWordBookDialog = false;
        this.dictationDialogVisible = false;
        this.reviewGroupid = null;
        return;
      }

      
      const wordBookDialog = this.$refs.wordBookDialog;
      if (
        this.showWordBookDialog &&
        wordBookDialog &&
        wordBookDialog.isFlipped === true
      ) {
        
        
        return;
      }

      
      const nextIndex = (currentIndex + 1).toString();

      getReviewNextWord({
        groupid: this.reviewGroupid,
        currentIndex: nextIndex,
      }).then((res) => {
        const data = res?.data || {};
        if (!data.vocabulary_info) {
          
          this.$message?.success("复习完成！");
          localStorage.setItem("need-review", "false");
          this.showWordBookDialog = false;
          this.reviewGroupid = null;
          return;
        }

        
        
        const newCurrentIndex = data?.current_index || "1";
        const total = data?.total || 0;

        
        this.wordBookProgress = `${newCurrentIndex}/${total}`;

        
        this.wordBookData = data;

        
        const currentIdx = parseInt(newCurrentIndex);
        if (currentIdx > total && total > 0) {
          this.$message?.success("复习完成！");
          this.showWordBookDialog = false;
          this.dictationDialogVisible = false;
          this.reviewGroupid = null;
          return;
        }

        
        if (data?.info?.type === "write") {
          this.write = ""; 
          this.dictationDialogVisible = true;
          this.showWordBookDialog = false;
          this.pay(data);
        } else {
          this.showWordBookDialog = true;
          this.dictationDialogVisible = false;
          
          
          
          
          
          
        }
      });
    },
    
    handleDictationClose() {
      this.dictationDialogVisible = false;
    },
    
    handleDictationNext(nextWordData) {
      
      if (nextWordData && nextWordData.vocabulary_info) {
        
        const currentIndex = parseInt(nextWordData.current_index || "1");
        const total = nextWordData.total || 0;

        
        this.wordBookProgress = `${currentIndex}/${total}`;

        
        this.wordBookData = nextWordData;

        
        if (currentIndex > total && total > 0) {
          this.dictationDialogVisible = false;
          this.showWordBookDialog = false;
          this.reviewGroupid = null;
          this.$message?.success("复习完成！");
          return;
        }

        
        if (currentIndex === total && total > 0) {
          
          const answerStatus =
            nextWordData.answer_status || nextWordData.data?.answer_status;
          if (answerStatus === true) {
            
            this.dictationDialogVisible = false;
            this.showWordBookDialog = false;
            this.reviewGroupid = null;
            this.$message?.success("复习完成！");
            return;
          } else {
            
            
            if (nextWordData.info?.type === "write") {
              this.write = ""; 
              this.dictationDialogVisible = true;
              this.showWordBookDialog = false;
               this.pay(data);
            } else {
              this.showWordBookDialog = true;
              this.dictationDialogVisible = false;
            }
            return;
          }
        }

        
        if (nextWordData.info?.type === "write") {
          this.write = ""; 
          this.dictationDialogVisible = true;
          this.showWordBookDialog = false;
           this.pay(data);
        } else {
          this.showWordBookDialog = true;
          this.dictationDialogVisible = false;
        }
      } else {
        
        
        const currentIndex = parseInt(this.wordBookData?.current_index || "1");
        const total = this.wordBookData?.total || 0;
        if (currentIndex === total && total > 0) {
          
          const answerStatus = nextWordData?.answer_status;
          if (answerStatus === true) {
            
            this.dictationDialogVisible = false;
            this.showWordBookDialog = false;
            this.reviewGroupid = null;
            this.$message?.success("复习完成！");
            return;
          } else {
            
            return;
          }
        }

        
        if (currentIndex > total && total > 0) {
          this.dictationDialogVisible = false;
          this.showWordBookDialog = false;
          this.reviewGroupid = null;
          this.$message?.success("复习完成！");
          return;
        }

        
        this.loadReviewNextWord();
      }
    },
    
    handleDictationSkip() {
      
      this.dictationDialogVisible = false;
      
      const currentIndex = parseInt(this.wordBookData?.current_index || "1");
      const total = this.wordBookData?.total || 0;
      if (currentIndex >= total && total > 0) {
        this.showWordBookDialog = false;
        this.reviewGroupid = null;
        this.$message?.success("复习完成！");
        return;
      }
      this.loadReviewNextWord();
    },
  },
};
